import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
  Box,
} from "@mui/material";

const TableSkeletonLoader = ({ columnsCount = 6, rowsCount = 6, modern = false }) => {
  return (
    <TableContainer
      sx={{
        width: '100%',
        maxWidth: '100%', // 100vw ignored the sidebar/page padding and could push the page sideways
        overflowX: 'auto',
        overflowY: 'auto',
        ...(modern && { borderRadius: 3, border: "1px solid #e5e7eb", bgcolor: "#fff" }),
        "&::-webkit-scrollbar": { height: "6px", width: "6px" },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#888",
          borderRadius: "4px",
        },
        "&::-webkit-scrollbar-thumb:hover": { backgroundColor: "#555" },
        scrollbarWidth: "thin",
        scrollbarColor: "#888 #f1f1f1",
      }}
    >

      <Table stickyHeader sx={{
        width: '100%',
        minWidth: modern ? 0 : '1200px',
        tableLayout: 'auto', // header defines width
      }}>
        {/* --- Table Header --- */}
        <TableHead>
          <TableRow>
            {[...Array(columnsCount)].map((_, colIdx) => (
              <TableCell
                key={colIdx}
                align="center"
                sx={
                  modern
                    ? {
                        // light ash header, same as the modern table
                        backgroundColor: "#f3f4f6",
                        borderBottom: "1px solid #d1d5db",
                        padding: "10px 12px",
                        whiteSpace: "nowrap",
                      }
                    : {
                        fontWeight: "bold",
                        textTransform: "capitalize",
                        backgroundColor: "var(--primary)",
                        color: "#fff",
                        position: "static",
                        right: undefined,
                        zIndex: 1,
                        whiteSpace: "nowrap",
                        maxWidth: 'clamp(180px, 30vw, 600px)',
                        padding: "12px",
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        borderRight: "2px solid rgba(226, 224, 224, 0.8)",
                      }
                }
              >
                <Skeleton
                  variant={modern ? "rounded" : "text"}
                  width={`${60 + Math.random() * 40}%`}
                  height={modern ? 14 : 30}
                  sx={{ bgcolor: modern ? "#e5e7eb" : "rgba(255,255,255,0.3)", mx: modern ? "auto" : undefined }}
                />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        {/* --- Table Body --- */}
        <TableBody>
          {[...Array(rowsCount)].map((_, rowIdx) => (
            <TableRow key={rowIdx}>
              {[...Array(columnsCount)].map((_, colIdx) => (
                <TableCell
                  key={colIdx}
                  align="center"
                  sx={modern ? {
                    borderBottom: "1px solid #ececee",
                    padding: "10px 12px",
                    whiteSpace: "nowrap",
                  } : {
                    border: "1px solid rgba(226, 224, 224, 0.5)",
                    position: "static",
                    right: undefined,
                    backgroundColor: "inherit",
                    zIndex: 0,
                    whiteSpace: "nowrap",
                    wordBreak: "ellipsis",
                    maxWidth: 'clamp(180px, 30vw, 600px)',
                    overflow: 'hidden',
                    padding: "5px",
                  }}
                >
                  <Skeleton
                    variant={modern ? "rounded" : "rectangular"}
                    width={`${40 + Math.random() * 40}%`}
                    height={modern ? 16 : 24}
                    sx={{ borderRadius: modern ? "8px" : "4px", mx: modern ? "auto" : undefined, bgcolor: modern ? "#f1f5f9" : undefined }}
                  />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableSkeletonLoader;
